import { generateURIWithQueryParams } from '@xmatters/redux/services/util';

export const SEARCH = 'SEARCH';
export const SEARCH_SUCCESS = `${SEARCH}_SUCCESS`;
export const SEARCH_FAIL = `${SEARCH}_FAIL`;

export const doSearch = (uri, params, type = SEARCH, method = 'get') => ({
  type,
  meta: {
    xmApi: true,
    method,
    uri,
    params,
    customUriWithParamsGenerator: generateURIWithQueryParams,
  },
  payload: params,
});
